import AppraisalRequestCard from './appraisal-request-card';

export default AppraisalRequestCard;
